export const inputCls =
  "w-full border border-line bg-slate-100/70 px-4 py-4 text-base text-slate-900 placeholder-zinc-500 outline-none transition-all duration-300 focus:border-blaze focus:bg-slate-100/70 sm:text-sm";

export const labelCls = "mb-2 block text-[10px] font-bold uppercase tracking-[0.25em] text-slate-500";

export const StepNav = ({ onBack, onNext, nextLabel = "Continue", nextDisabled = false, testid }) => (
  <div className="mt-10 flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
    {onBack ? (
      <button onClick={onBack} className="w-full border border-line px-6 py-4 text-xs font-bold uppercase tracking-widest text-slate-600 transition-colors hover:border-white hover:text-slate-900 sm:w-auto sm:py-3.5" data-testid="step-back-btn">
        Back
      </button>
    ) : <span className="hidden sm:inline" />}
    <button
      onClick={onNext}
      disabled={nextDisabled}
      data-testid={testid || "step-next-btn"}
      className="w-full bg-blaze px-8 py-4 text-sm font-bold uppercase tracking-widest text-white transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_0_30px_rgba(37,99,235,0.4)] disabled:opacity-40 disabled:hover:scale-100 sm:w-auto sm:py-3.5 sm:text-xs"
    >
      {nextLabel}
    </button>
  </div>
);

export const StepHeading = ({ kicker, title, sub }) => (
  <div className="mb-10">
    <p className="mb-3 text-xs font-bold uppercase tracking-[0.3em] text-blaze">{kicker}</p>
    <h2 className="font-display text-3xl font-semibold uppercase tracking-tighter sm:text-4xl">{title}</h2>
    {sub && <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-600">{sub}</p>}
  </div>
);

export const Pill = ({ active, onClick, children, testid }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testid}
    className={`border px-5 py-3 text-sm font-semibold transition-all duration-300 ${
      active ? "border-blaze bg-blaze text-white" : "border-line text-slate-700 hover:border-blaze/60 hover:text-white"
    }`}
  >
    {children}
  </button>
);
